<template>
  <div>
      <span v-if="rank == 1" class="ranking-personal-number"><img src="../../../assets/img/personal-one.png" class="ranking-top-one"></span>
      <span v-else-if="rank == 2" class="ranking-personal-number"><img src="../../../assets/img/personal-two.png" class="ranking-top-two"></span>
      <span v-else-if="rank == 3" class="ranking-personal-number"><img src="../../../assets/img/personal-three.png" class="ranking-top-three"></span>
      <span v-else class="ranking-personal-number mgr10">{{rank}}</span>
  </div>
</template>

<script>
  export default {
    data: function (){
      return {}
    },
    props: ['rank']
  }
</script>

<style scoped>
 .ranking-personal-number{
   height: 48px;
   line-height:48px;
   float: left;
   font-size: 14px;
   margin-right: 20px;
   color: #666;
   width: 36px;
   text-align: center;
 }
 .ranking-top-one{
   height: 48px;
 }
 .ranking-top-two{
   height: 48px;
 }
 .ranking-top-three{
   height: 48px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/rankPic.vue